module.exports = __webpack_public_path__ + "static/media/home_icon2.aed39c9c.svg";